import { render, staticRenderFns } from "./IncomeCosigner.vue?vue&type=template&id=28734502&"
import script from "./IncomeCosigner.vue?vue&type=script&lang=js&"
export * from "./IncomeCosigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports